import styleInject from '../../node_modules/.pnpm/style-inject@0.3.0/node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".vai-table__row {\n  height: var(--vai-table-row-height);\n  vertical-align: middle;\n  background-color: var(--vai-color-bg);\n  background-clip: padding-box;\n}";
styleInject(css_248z,{"insertAt":"top"});

export { css_248z as default };
